














import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import { $t } from "@/lib/i18nHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

@Component({ name: "CallStateView", components: { BaseButton, BaseAvatar, BaseIcon } })
export default class CallStateView extends mixins(WithAuthUser) {
  @Prop({ type: Boolean, default: false })
  public readonly showConnectionError!: boolean;

  @Prop({ type: String, default: "" })
  public readonly connectionErrorMessage!: string;

  @Prop({ required: true })
  public readonly opponentUser!: UserPublicData;

  @Prop({ required: true })
  public readonly processingVideoRequest!: boolean;

  public get subtitle() {
    if (this.showConnectionError) return $t("Connection lost");
    if (this.processingVideoRequest) return $t("Switching to video chat...");
    return "";
  }
  public get caption() {
    if (this.connectionErrorMessage) {
      return this.connectionErrorMessage;
    } else if (this.showConnectionError) {
      return $t("Call ended due to connection error.");
    }
    if (this.processingVideoRequest) return $t("{0} needs to agree to video chat.", [this.opponentUser.screenName]);
    return "";
  }
  public get buttonText() {
    if (this.showConnectionError) return $t("Call back");
    if (this.processingVideoRequest) return $t("Cancel");
    return "";
  }
  public get hasAnyText(): boolean {
    return this.subtitle !== "" && this.caption !== "" && this.buttonText !== "";
  }

  public get classname() {
    if (this.showConnectionError) return "__connection-error";
    if (this.processingVideoRequest) return "__processing-video";
    return ";";
  }
}
